import { ICommandResult } from "../../../Common/domain/src/api/commandResult";
import { initialState } from "../../../Common/reducers";
import { customerClient } from "../../api/customersClient";
import { IAssociateCommand } from "../../commands/association";
import {
  START_ASSOCIATION_FLOW,
  START_ASSOCIATION_FLOW_FAIL,
  AssociationFlowType,
  START_CUSTOMERSSHORTNAMEANDCODE_FLOW,
  START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL,
  CustomerShortNameAndCode,
  GetCustomersShortNameAndCodeType
} from "../../domain/association/index";

// in actions folder
export const returnCustomerShortCodeAction = (result: CustomerShortNameAndCode[]): GetCustomersShortNameAndCodeType => {
  return {
    type: START_CUSTOMERSSHORTNAMEANDCODE_FLOW,
    payload: result,
  };
};

export const returnCustomerShortCodeFailAction = (err: CustomerShortNameAndCode[]): GetCustomersShortNameAndCodeType => {
  return {
    type: START_CUSTOMERSSHORTNAMEANDCODE_FLOW_FAIL,
    payload: err,
  };
};

export const startAssociationFlowAction = ( result: ICommandResult ): AssociationFlowType => {
	return {
	  type: START_ASSOCIATION_FLOW,
	  payload: result,
	};
};
  
  export const startAssociationFailAction = ( err: ICommandResult): AssociationFlowType => {
	return {
	  type: START_ASSOCIATION_FLOW_FAIL,
	  payload: err,
	};
};


export const handleReturnCustomersShortNameAndCode = (token: string) => {
  return function (dispatch: any) {
    const endpoint = new customerClient();
    endpoint.getCustomersShortNameAndCode(token)
      .then((data) => {
        if (!data.isValid) {
          dispatch(returnCustomerShortCodeFailAction(initialState.getCustomers.result));
          return initialState.association.result;
        }
        let customerResponseJson = JSON.parse(JSON.stringify(data));
        let customerDataJson = customerResponseJson["data"];
        let customers = customerDataJson.map((customer: any) =>
          <CustomerShortNameAndCode>{
            code: customer.code,
            shortName: customer.shortName
          });
        dispatch(returnCustomerShortCodeAction(customers));
        return customers;
      })
      .catch((err) => {
        console.log(err);
        dispatch(returnCustomerShortCodeFailAction(initialState.getCustomers.result));
      });
  };
};

export const handleAssociation = (token: string, command: IAssociateCommand) => {
  return function (dispatch: any) {
    const endpoint = new customerClient();
    endpoint.associateWithCustomer(token, command)
      .then((data) => {
        if (!data.isValid) {
          dispatch(startAssociationFailAction(data));
          return data;
        }
        dispatch(startAssociationFlowAction(data));
        return data;
      })
      .catch((err) => {
        dispatch(startAssociationFailAction(err));
      });
  };
};